export default __webpack_public_path__ + "static/media/gallery-image-4.3f9f9c64.png";